import React, { useRef } from 'react'
import Link from '../../link'
import { Card, MediaWrap, Trivia } from './atoms'
import { CmsContentService } from '../../../services'
import { useLazyImg } from '../../../hooks'

const NewsCard = ({ title, date, slug, content }) => {
  const imgRef = useRef(null)
  const imgSource = CmsContentService.getCoverImg(content)
  const { imgSrc } = useLazyImg({ imgUrl: imgSource, target: imgRef })
  const currentPackageName = process.env.GATSBY_PACKAGE_NAME
  return (
    <Card ref={imgRef}>
      <MediaWrap>
        <Link to={`/news/${slug}/`} isInternal={currentPackageName === 'news'}>
          <img src={imgSrc} alt='' />
        </Link>
      </MediaWrap>
      <Trivia>
        <Link to={`/news/${slug}/`} isInternal={currentPackageName === 'news'}>
          {title}
        </Link>
        <p>{date}</p>
      </Trivia>
    </Card>
  )
}
// class NewsCard extends React.PureComponent {
//   render() {
//     const { title, date, slug, content } = this.props
//     const imgSource = CmsContentService.getCoverImg(content)
//     const currentPackageName = process.env.GATSBY_PACKAGE_NAME
//     return (
//       <Card>
//         <Media>
//           <Link to={`/news/${slug}/`} isInternal={currentPackageName === 'news'}>
//             <img src={imgSource} alt='' />
//           </Link>
//         </Media>
//         <Trivia>
//           <Link to={`/news/${slug}/`} isInternal={currentPackageName === 'news'}>
//             {title}
//           </Link>
//           <p>{date}</p>
//         </Trivia>
//       </Card>
//     )
//   }
// }

export default NewsCard
